import ts from "typescript/lib/tsserverlibrary";

export type Lesson = {
  name: string;
  organization: string;
  shortDescription: string;
  recommendAges: number[];
  interests: string[];
}

export const demoLessons: Lesson[] = [
  {
    name: "Объединение «Информационные технологии»",
    organization: "Станция юных техников",
    shortDescription: "Научим использовать компьютер и основные программы, решать задачи по информатике и программировать на разных языках. Можно начинать как с раннего возраста, так и в старших классах.",
    recommendAges: [6, 18],
    interests: ["информатика", "программирование"],
  },
  {
    name: "Тайский бокс",
    organization: "Спортивный клуб «Богдан»",
    shortDescription: "Тренировки и участие в соревнованиях по правилам тайского бокса.",
    recommendAges: [6, 18],
    interests: ["спорт", "бокс"],
  },
  {
    name: "Шахматы",
    organization: "Клуб шахматистов",
    shortDescription: "Шахматы позволяют развить мышление и логику. Лучше начинать с раннего возраста.",
    recommendAges: [6, 18],
    interests: ["шахматы"],
  },
  {
    name: "Спортивный туризм",
    organization: "Пилигрим",
    shortDescription: "Лучшие тренера города помогут достичь высот в области спорттуризма.",
    recommendAges: [6],
    interests: ["спорт", "туризм"],
  },
  {
    name: "Спортивное ориентирование",
    organization: "Пилигрим",
    shortDescription: "Лучшие тренера города научат ориентироваться на местности, читать карту и пользоваться компасом.",
    recommendAges: [6],
    interests: ["спорт", "ориентирование"],
  },
  {
    name: "Искусство театра",
    organization: "Детская театральная школа",
    shortDescription: "Обучение театральному искусству детей школьного возраста.",
    recommendAges: [6],
    interests: ["искусство", "театр"],
  },
]

export const demoInterestsList = ["информатика", "программирование", "шахматы", "спорт", "туризм", "ориентирование", "бокс", "искусство", "театр"]
export const demoInterestsCount = [1, 1, 1, 1, 1]

export function searchByInterests(lessons: Lesson[], interests: string[], age: number) : Lesson[] {
  console.log(interests)
  let result = lessons.map((lesson, key) => {
    let count = lesson.interests.some(v => interests.includes(v))
    console.log(lesson.name, count, (age >= lesson.recommendAges[0] && (lesson.recommendAges.length < 2 || age <= lesson.recommendAges[1])))
    if (count) {
      if (age >= lesson.recommendAges[0] && (lesson.recommendAges.length < 2 || age <= lesson.recommendAges[1]))
        return lesson
    }
    return undefined
  })
  console.log(result)
  result = result.filter((prop, key) => prop !== undefined)
  console.log(result)
  // @ts-ignore
  return result
}

export function goToResults(interests: string[], history: any) {
  history.push("/results?interests=" + interests.join(","))
}

export function getInterestsFromLink(param: string): string[] {
  if (param) {
    let interests = param.split(",")
    interests = interests.filter(v => demoInterestsList.includes(v))
    return interests
  }
  return []
}